import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  Image,
  PDFDownloadLink,
} from "@react-pdf/renderer";
import logo from "../../pages/tecnicalCard/images/proluxLogo.png";

const ProluxCardHeader = ({ techData, date }) => {
  return (
    <View fixed>
      <View
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          paddingTop: "20px",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <View>
          <Text>Technisches Datenblatt COMPACT PRO</Text>
        </View>
        <View>
          <Image src={logo} alt="logo" style={{ width: "200px" }} />
        </View>
      </View>
      <View
        style={{
          display: "flex",
          flexDirection: "row",
          border: "2px solid black",
          flexWrap: "wrap",
          fontSize: "8px",
          paddingHorizontal: "5px",
        }}
      >
        <Text style={{ width: "50%" }}>Offerte</Text>
        <Text style={{ width: "50%" }}>Kunde: {techData.customer.name}</Text>
        <Text style={{ width: "50%" }}></Text>
        <Text style={{ width: "50%" }}>
          Objekt:{" "}
          {techData.project +
            ", " +
            techData.location +
            ", " +
            techData.address}{" "}
        </Text>
        <Text style={{ width: "50%" }}>{date}</Text>
        <Text style={{ width: "50%" }}>Anlage (Gerät)</Text>
      </View>
    </View>
  );
};

export default ProluxCardHeader;
